import React, { useContext } from 'react';
import { useField, useForm } from 'react-final-form';

import Button from '@swf/components/StarsButton/StarsButton';
import Translation from '@swf/components/Translation/Translation';
import { Checkbox } from '@swf/poker';

import CreateTournamentContext from '../../CreateTournamentContext/CreateTournamentContext';
import type { FormValues } from '../../utils/common';

import { TXTCLI_Edit, TXTCLI_Make_recurring } from './Toggle.messages.json';
import styles from './Toggle.scss';

const RecurrenceToggle: React.FC = () => {
  const { setState } = useContext(CreateTournamentContext);
  const { change } = useForm<FormValues>();
  const {
    input: { value }
  } = useField('repeat', { defaultValue: false });

  const handleEditRecurrence = () => {
    setState((prevState) => ({ ...prevState, isRecurrenceOpen: true }));
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    change('repeat', event.target.checked);
  };

  return (
    <div className={styles.toggleContainer}>
      <Checkbox
        id="repeat"
        value={value}
        checked={value}
        label={<Translation {...TXTCLI_Make_recurring} />}
        onChange={handleChange}
      />
      <Button
        onClick={handleEditRecurrence}
        id="edit"
        type="submit"
        translation={TXTCLI_Edit}
        className={styles.submit}
        variant="text"
      />
    </div>
  );
};

export default RecurrenceToggle;
